import React, { FC } from 'react'
import { useKeenSlider } from 'keen-slider/react'
import s from './TagsByRestaurant.module.sass'

import { BtnFilterTag } from '@shared/ui/Form/Single/Filters/DefaultTag'
import { BtnFilterAfishaTag } from '@shared/ui/Form/Single/Filters/AfishaTag'

import { findDataTagForAnalyticBySlug } from '@features/Restaurant/RestaurantFilters/helpers/helper'
import { EGG } from '@shared/api/analytics'
import { TypeMappingRestTag } from '@shared/api/middleware/mappingAPI/restaurant/type'

interface Props {
  tags: TypeMappingRestTag[]
  restId: number
  className?: string
}

const TagsByRestaurant: FC<Props & React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>> = ({
  tags,
  restId,
  className = '',
  ...props
}) => {
  const [sliderRef] = useKeenSlider({
    mode: 'free',
    slides: {
      perView: 'auto',
      spacing: 6,
    },
    selector: `.${s.tag}`,
  })

  const handleOpenTagPage = (tagElem) => {
    if (tagElem.url) {
      const dataTag = findDataTagForAnalyticBySlug(tagElem.slug)
      const urlSplit = tagElem.url.split('/')
      const getSlug = urlSplit[urlSplit.length - 2]
      EGG.common.tag_click({
        filter_apply_type: dataTag.type,
        filter_apply_value: dataTag.value || getSlug,
      })
    }
  }

  return (
    <div className={`${s['tag-wrapper']} ${className}`} {...props}>
      <ul className={`keen-slider`} ref={sliderRef} key={`slider-${restId}`}>
        {!!tags.length &&
          tags.map((el, i) => {
            return (
              <div className={s.tag} key={`${restId}-${el.url}`}>
                {el.has_selection ? (
                  <BtnFilterAfishaTag onClick={() => handleOpenTagPage(el)} to={el.url}>
                    {el.name}
                  </BtnFilterAfishaTag>
                ) : (
                  <BtnFilterTag onClick={() => handleOpenTagPage(el)} to={el.url}>
                    {el.name}
                  </BtnFilterTag>
                )}
              </div>
            )
          })}
      </ul>
    </div>
  )
}

export default TagsByRestaurant
